<template>
  <div>
    <b-card
      no-body
      class="liveinfo-form"
    >
      <div class="m-2">
        <b-row>
          <b-col
            cols="12"
            md="10"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <b-form-input
              v-model="filterStr"
              placeholder="타겟그룹 이름"
              class="el-def"
              @keyup.enter="refetchData()"
            />
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="2"
            class="d-flex align-items-center justify-content-end"
          >
            <b-button
              variant="primary"
              class="btn-search"
              @click.prevent="refetchData()"
            >
              조회
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-card
      no-body
    >
      <div class="m-2">
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start"
          >
            <h5 class="mb-0 ml-50">
              타겟그룹 리스트 [{{ totalRecords }}] 건
            </h5>
          </b-col>
        </b-row>
      </div>
      <b-table
        primary-key="id"
        :items="targetGroupList"
        :fields="tableColumns"
        responsive
        sticky-header
        selectable
        select-mode="single"
        class="position-relative"
        @row-selected="onRowSelected"
      />
    </b-card>
    <b-card
      no-body
    >
      <div class="m-2">
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start"
          >
            <feather-icon
              icon="EditIcon"
              size="19"
            />
            <h4 class="mb-0 ml-50">
              상세
            </h4>
          </b-col>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-end"
          >
            <b-button
              variant="outline-secondary"
              class="mr-1"
              :disabled="!targetGroupData.id || targetGroupEtcData.copyDisabled"
              @click.stop="copyTargetGroup"
            >
              <feather-icon
                icon="CopyIcon"
                class="mr-50"
              />
              <span>타겟그룹 복사</span>
            </b-button>
            <b-button
              variant="outline-primary"
              @click.stop="resetTargetGroup"
            >
              <feather-icon
                icon="PlusSquareIcon"
                class="mr-50"
              />
              <span>신규</span>
            </b-button>
            <b-button
              :disabled="isSaving"
              variant="primary"
              class="ml-1"
              @click.stop="saveTargetGroup"
            >
              <feather-icon
                icon="SaveIcon"
                class="mr-50"
              />
              <span>저장</span>
            </b-button>
            <b-button
              variant="outline-secondary"
              class="ml-1"
              @click.stop="removeTargetGroup"
            >
              <feather-icon
                icon="Trash2Icon"
                class="mr-50"
              />
              <span>삭제</span>
            </b-button>
          </b-col>
        </b-row>

        <validation-observer ref="formRules">
          <b-row class="mt-1">
            <b-col
              cols="12"
              md="6"
            >

              <b-form-group
                label="이름"
                label-for="targetGroupTitle"
              >

                <validation-provider
                  #default="{ errors }"
                  name="이름"
                  rules="required"
                >

                  <b-form-input
                    id="targetGroupTitle"
                    v-model="targetGroupData.targetGroupTitle"
                    :state="errors.length > 0 ? false : null"
                  />

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>

              </b-form-group>

            </b-col>
          </b-row>
          <b-row class="mt-1">
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group
                label="설정된 타겟 조건"
                label-for="targetConditions"
              >
                <validation-provider
                  #default="{ errors }"
                  name="타겟 조건"
                  rules="required"
                >
                  <b-form-input
                    id="activeFilterTypesHidden"
                    :value="activeFilterTypes.length > 0 ? 'valid' : ''"
                    style="display:none"
                  />
                  <div id="targetConditions">
                    <div
                      v-if="activeFilterTypes.length === 0"
                      class="text-muted"
                    >
                      설정된 타겟 조건이 없습니다.
                    </div>
                    <div
                      v-else
                      class="d-flex flex-wrap"
                    >
                      <b-badge
                        v-for="filterType in activeFilterTypes"
                        :key="filterType"
                        variant="light-dark"
                        class="mr-1 mb-1"
                      >
                        {{ getFilterName(filterType) }}
                      </b-badge>
                    </div>
                  </div>
                  <small class="text-danger">
                    {{ errors[0] ? '[타겟 조건]는(은) 필수 입력입니다. 타겟 조건 중 1개 이상 설정해 주세요.' : '' }}
                  </small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
        <b-row class="mt-1">
          <b-col
            cols="12"
            md="6"
          >
            타겟 인원
            <b-badge
              v-b-tooltip.hover.right.html
              variant="light-secondary"
              style="padding: 0px; margin-left: 5px;"
              :title="`<ul style='text-align: left; padding-left: 1rem; margin: 0;'>
                          <li>진료과/지역/처방제외/간편처방 제외조건/컨텐츠 미열람/팝업 미노출/설문 미완료만 설정할 경우, 최근 1개월간 닥터인포를 실행한 인원을 전체 사용자로 타겟을 산정합니다.</li>
                          <li>그 외 조건과 함께 설정할 경우, 해당 조건으로 추려진 인원에 진료과/지역/처방제외/간편처방 제외조건/컨텐츠 미열람/팝업 미노출/설문 미완료 인원이 필터링되어 타겟을 산정합니다.</li>
                        </ul>`"
            >
              <feather-icon icon="InfoIcon" />
            </b-badge>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col
            cols="12"
            md="6"
          >
            <div
              v-if="targetGroupEtcData.isBeforeReleaseDate2nd"
              class="d-flex align-items-center"
            >
              <b-button
                variant="outline-primary"
                :disabled="targetGroupEtcData.targetCountInfo.isLoading || !!targetGroupData.id"
                @click.stop="getTargetCount"
              >
                <span>타겟 인원 조회</span>
              </b-button>
              <div class="ml-3 align-items-center">
                <b-spinner
                  v-if="targetGroupEtcData.targetCountInfo.isLoading"
                  small
                  class="mr-50"
                />
                <span
                  v-else
                  class="text-primary font-weight-bold"
                >{{ targetGroupEtcData.targetCountInfo.count | $numberFormatter }}명 포함</span>
                <span
                  :class="[
                    'ml-1 text-link',
                    targetGroupEtcData.targetCountInfo.count > 0 ? 'text-primary' : 'text-muted'
                  ]"
                  :style="{
                    textDecoration: 'underline',
                    pointerEvents: targetGroupEtcData.targetCountInfo.count > 0 ? 'auto' : 'none'
                  }"
                  @click="showTargetCountDetailModal"
                >
                  상세보기
                </span>
                <target-count-detail
                  :show-target-count-detail="targetGroupEtcData.targetCountInfo.showTargetCountDetail"
                  :data="targetGroupEtcData.targetCountInfo.targetCountDetailList"
                  :total-target-count="targetGroupEtcData.targetCountInfo.count"
                  @close="targetGroupEtcData.targetCountInfo.showTargetCountDetail = false"
                />
              </div>
            </div>
            <div v-else>
              <span>타겟그룹 업데이트로 {{ ReleaseDate2nd }} 이전의 타겟인원 상세보기는 제공되지 않습니다.</span>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <b-card>
      <validation-observer ref="departmentRules">
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start"
          >
            <h4
              class="mb-0 ml-50"
              style="min-width: 200px"
            >
              진료과 타겟
            </h4>
            <b-form-checkbox
              v-model="filterToggleStates.department"
              :disabled="!!targetGroupData.id"
              switch
              inline
              class="custom-control-info"
              style="min-width: 120px"
            >
              {{ filterToggleStates.department ? '사용' : '사용안함' }}
            </b-form-checkbox>
          </b-col>
          <b-col
            v-if="filterToggleStates.department"
            cols="10"
            class="mt-1"
          >
            <b-form-group>
              <label for="seminar-cond-dept">진료과</label>
              <validation-provider
                #default="{ errors }"
                name="진료과"
                rules="required"
              >
                <b-form-input
                  id="seminar-cond-dept"
                  v-model="record.condDeptNames"
                  readonly
                  :state="errors.length > 0 ? false : null"
                  :disabled="!!targetGroupData.id"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            v-if="filterToggleStates.department"
            cols="2"
            class="mt-1"
          >
            <b-button
              variant="outline-primary"
              class="mt-0 mt-md-2"
              :disabled="!!targetGroupData.id"
              @click.prevent="showMediDeptSelect = true"
            >
              <feather-icon
                icon="PlusSquareIcon"
                class="mr-50"
              />
              <span>진료과 선택</span>
            </b-button>
          </b-col>
        </b-row>
      </validation-observer>
    </b-card>
    <b-card>
      <validation-observer ref="regionRules">
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start"
          >
            <h4
              class="mb-0 ml-50"
              style="min-width: 200px"
            >
              지역 타겟
            </h4>
            <b-form-checkbox
              v-model="filterToggleStates.region"
              :disabled="!!targetGroupData.id"
              switch
              inline
              class="custom-control-info"
              style="min-width: 120px"
            >
              {{ filterToggleStates.region ? '사용' : '사용안함' }}
            </b-form-checkbox>
          </b-col>
          <b-col
            v-if="filterToggleStates.region"
            cols="10"
            class="mt-1"
          >
            <b-form-group>
              <b-form-group>
                <label for="seminar-cond-region">지역</label>
                <validation-provider
                  #default="{ errors }"
                  name="지역"
                  rules="required"
                >
                  <b-form-input
                    id="seminar-cond-region"
                    v-model="record.condRegionNames"
                    readonly
                    :state="errors.length > 0 ? false : null"
                    :disabled="!!targetGroupData.id"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-form-group></b-col>
          <b-col
            v-if="filterToggleStates.region"
            cols="2"
            class="mt-1"
          >
            <b-button
              variant="outline-primary"
              class="mt-0 mt-md-2"
              :disabled="!!targetGroupData.id"
              @click.prevent="showRegionSelect = true"
            >
              <feather-icon
                icon="PlusSquareIcon"
                class="mr-50"
              />
              <span>지역 선택</span>
            </b-button>
          </b-col>
        </b-row>
      </validation-observer>
    </b-card>

    <b-card>
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start"
        >
          <h4
            class="mb-0 ml-50"
            style="min-width: 200px"
          >
            처방(라이브 DI) 타겟
          </h4>
          <b-form-checkbox
            v-model="filterToggleStates.liveDi"
            :disabled="!!targetGroupData.id"
            switch
            inline
            class="custom-control-info"
            style="min-width: 120px"
          >
            {{ filterToggleStates.liveDi ? '사용' : '사용안함' }}
          </b-form-checkbox>
        </b-col>
      </b-row>
      <target-group-livedi-filter
        :target-group-data="targetGroupData"
        :codes="codes"
        :is-readonly="!!targetGroupData.id"
        :filter-type="liveDiTypeCode"
        :live-di-toggle-state="filterToggleStates.liveDi"
      />
      <small
        v-if="!hasValidFilters.liveDi && filterToggleStates.liveDi"
        class="text-danger"
      >
        [처방 포함] 또는 [처방 제외]는(은) 필수 입력입니다.
      </small>
    </b-card>
    <b-card>
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start"
        >
          <h4
            class="mb-0 ml-50"
            style="min-width: 200px"
          >
            활동 타겟
          </h4>
          <b-form-checkbox
            v-model="filterToggleStates.activity"
            :disabled="!!targetGroupData.id"
            switch
            inline
            class="custom-control-info"
            style="min-width: 120px"
          >
            {{ filterToggleStates.activity ? '사용' : '사용안함' }}
          </b-form-checkbox>
        </b-col>
      </b-row>
      <target-group-activity-filter
        :target-group-data="targetGroupData"
        :codes="codes"
        :is-readonly="!!targetGroupData.id"
        :filter-type="activityTypeCode"
        :activity-toggle-state="filterToggleStates.activity"
        @valid-change="validChanged => {
          activityFilterValidFlag = validChanged
        }"
      />
      <small
        v-if="!hasValidFilters.activity && filterToggleStates.activity"
        class="text-danger"
      >
        [활동]는(은) 필수 입력입니다.
      </small>
    </b-card>
    <b-card>
      <validation-observer ref="interestContentRules">
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start"
          >
            <h4
              class="mb-0 ml-50"
              style="min-width: 200px"
            >
              관심 컨텐츠 유형 타겟
            </h4>
            <b-form-checkbox
              v-model="filterToggleStates.interestContent"
              :disabled="!!targetGroupData.id"
              switch
              inline
              class="custom-control-info"
              style="min-width: 120px"
            >
              {{ filterToggleStates.interestContent ? '사용' : '사용안함' }}
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row v-if="filterToggleStates.interestContent">
          <b-col
            cols="10"
            class="mt-1"
          >
            <b-form-group>
              <label for="interest-content-names">관심 컨텐츠 유형</label>
              <validation-provider
                #default="{ errors }"
                name="관심 컨텐츠 유형"
                rules="required"
              >
                <b-form-input
                  id="interest-content-names"
                  v-model="record.interestContentNames"
                  readonly
                  :state="errors.length > 0 ? false : null"
                  :disabled="!!targetGroupData.id"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            cols="2"
            class="mt-1"
          >
            <b-button
              variant="outline-primary"
              class="mt-0 mt-md-2"
              :disabled="!!targetGroupData.id"
              @click.prevent="showInterestContentSelect = true"
            >
              <feather-icon
                icon="PlusSquareIcon"
                class="mr-50"
              />
              <span>유형 선택</span>
            </b-button>
          </b-col>
        </b-row>
        <b-row v-if="filterToggleStates.interestContent">
          <b-col
            cols="2"
            class="mt-1"
          >
            <b-form-group>
              <label for="interest-content-start-date">
                타겟 추출 기준일(Fr)
                <b-badge
                  v-b-tooltip.hover.right.html
                  variant="light-secondary"
                  style="padding: 0px; margin-left: 5px;"
                  :title="`기준일 이후 해당 컨텐츠 유형에 관심을 보인(조회/투표) 사용자를 타겟그룹에 포함합니다.`"
                >
                  <feather-icon icon="InfoIcon" />
                </b-badge>
              </label>
              <validation-provider
                #default="{ errors }"
                name="타겟 추출 기준일(Fr)"
                rules="required"
              >
                <b-form-datepicker
                  id="interest-content-start-date"
                  v-model="record.interestContentStartDate"
                  placeholder="타겟 추출 기준일(Fr)"
                  style="width:200px;"
                  :state="errors.length > 0 ? false : null"
                  :disabled="!!targetGroupData.id"
                  :max="yesterdayDate"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <small
          v-if="!hasValidFilters.interestContent && filterToggleStates.interestContent"
          class="text-danger"
        >
          [관심 컨텐츠 유형]는(은) 필수 입력입니다.
        </small>
      </validation-observer>
    </b-card>
    <b-card>
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start"
        >
          <h4
            class="mb-0 ml-50"
            style="min-width: 200px"
          >
            설문 응답 타겟
          </h4>
          <b-form-checkbox
            v-model="filterToggleStates.surveyAnswer"
            :disabled="!!targetGroupData.id"
            switch
            inline
            class="custom-control-info"
            style="min-width: 120px"
          >
            {{ filterToggleStates.surveyAnswer ? '사용' : '사용안함' }}
          </b-form-checkbox>
        </b-col>
      </b-row>
      <target-group-survey-answer-filter
        :target-group-data="targetGroupData"
        :codes="codes"
        :is-readonly="!!targetGroupData.id"
        :filter-type="surveyAnswerTypeCode"
        :survey-answer-toggle-state="filterToggleStates.surveyAnswer"
      />
      <small
        v-if="!hasValidFilters.surveyAnswer && filterToggleStates.surveyAnswer"
        class="text-danger"
      >
        [설문응답]는(은) 필수 입력입니다.
      </small>
    </b-card>
    <b-card>
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start"
        >
          <h4
            class="mb-0 ml-50"
            style="min-width: 200px"
          >
            간편처방 타겟
          </h4>
          <b-form-checkbox
            v-model="filterToggleStates.drugLanding"
            :disabled="!!targetGroupData.id"
            switch
            inline
            class="custom-control-info"
            style="min-width: 120px"
          >
            {{ filterToggleStates.drugLanding ? '사용' : '사용안함' }}
          </b-form-checkbox>
        </b-col>
      </b-row>
      <b-row v-if="filterToggleStates.drugLanding">
        <b-col cols="12">
          <p class="text-muted ml-50 mt-50 mb-0">
            의사랑의 간편처방 등록 이력을 기반으로 특정 약품의 등록 여부로 사용자를 분류합니다.
          </p>
        </b-col>
      </b-row>
      <target-group-drug-landing-filter
        :target-group-data="targetGroupData"
        :codes="codes"
        :is-readonly="!!targetGroupData.id"
        :filter-type="drugLandingTypeCode"
        :drug-landing-toggle-state="filterToggleStates.drugLanding"
      />
      <small
        v-if="!hasValidFilters.drugLanding && filterToggleStates.drugLanding"
        class="text-danger"
      >
        [간편처방]는(은) 필수 입력입니다.
      </small>
    </b-card>

    <medi-dept-select
      :show-medi-dept-select="showMediDeptSelect"
      :selected-value="record.condDeptCodes"
      :is-block-all="true"
      @close="mediDeptSelect.close"
    />

    <region-select
      :show-region-select="showRegionSelect"
      :selected-value="record.condRegionCodes"
      :is-block-all="true"
      @close="regionSelect.close"
    />

    <interst-content-multi-select
      :show-interest-content-select="showInterestContentSelect"
      :selected-value="record.interestContentCodes"
      @close="interestContentSelect.close"
    />
  </div>
</template>

<script>
import axios from '@axios'
import dayjs from 'dayjs'
import {
  ref, onMounted, getCurrentInstance, computed, watch,
} from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import { required } from '@validations'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { errorFormatter, arrayJoinStr } from '@core/utils/filter'
import Ripple from 'vue-ripple-directive'
import { BBadge, VBTooltip, BSpinner } from 'bootstrap-vue'
import MediDeptSelect from '@/views/apps/popup/MediDeptSelect.vue'
import RegionSelect from '@/views/apps/popup/RegionSelect.vue'
import InterstContentMultiSelect from '@/views/apps/contents/interest-content/InterestContentMultiSelect.vue'
import TargetGroupLivediFilter from './filters/TargetGroupLivediFilter.vue'
import TargetGroupActivityFilter from './filters/TargetGroupActivityFilter.vue'
import TargetGroupSurveyAnswerFilter from './filters/TargetGroupSurveyAnswerFilter.vue'
import TargetGroupDrugLandingFilter from './filters/TargetGroupDrugLandingFilter.vue'
import TargetCountDetail from './TargetCountDetail.vue'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    TargetGroupLivediFilter,
    TargetGroupActivityFilter,
    TargetGroupSurveyAnswerFilter,
    TargetGroupDrugLandingFilter,
    TargetCountDetail,
    MediDeptSelect,
    RegionSelect,
    InterstContentMultiSelect,
    BBadge,
    BSpinner,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },

  setup() {
    onMounted(() => {
      fetchCodes()
    })

    const toast = useToast()
    const pushToast = (variant, title) => {
      let icon
      if (variant === 'success') {
        icon = 'CheckCircleIcon'
      } else {
        icon = 'AlertTriangleIcon'
      }

      toast({
        component: ToastificationContent,
        props: { title, icon, variant },
      })
    }
    const instance = getCurrentInstance()
    const refs = instance.proxy.$refs

    const activityFilterValidFlag = ref(false)
    const yesterdayDate = dayjs().add(-1, 'day').format('YYYY-MM-DD')

    // Set Codes
    const codes = ref({
      targetGroupStatus: [],
      targetGroupFilterType: [],
      targetGroupCountType: [],
      targetGroupActionType: [],
      postViewerRouteType: [],
      popupNonClickerRouteType: [],
    })

    // FilterCodes
    const liveDiTypeCode = computed(() => codes.value.targetGroupFilterType.find(t => t.label === '라이브DI')?.code)
    const departmentTypeCode = computed(() => codes.value.targetGroupFilterType.find(t => t.label === '진료과')?.code)
    const regionTypeCode = computed(() => codes.value.targetGroupFilterType.find(t => t.label === '지역')?.code)
    const activityTypeCode = computed(() => 40) // computed(() => codes.value.targetGroupFilterType.find(t => t.label === '활동')?.code)
    const interestContentTypeCode = computed(() => codes.value.targetGroupFilterType.find(t => t.label === '관심컨텐츠')?.code)
    const surveyAnswerTypeCode = computed(() => codes.value.targetGroupFilterType.find(t => t.label === '설문응답')?.code)
    const drugLandingTypeCode = computed(() => codes.value.targetGroupFilterType.find(t => t.label === '간편처방')?.code || 70)

    const activityDrugInfoTypeCode = computed(() => codes.value.targetGroupFilterType.find(t => t.label === '활동_약품정보')?.code)
    const activityMedicalTrendTypeCode = computed(() => codes.value.targetGroupFilterType.find(t => t.label === '활동_메디컬트렌드')?.code)
    const activitySurveyTypeCode = computed(() => codes.value.targetGroupFilterType.find(t => t.label === '활동_설문조사')?.code)
    // Set Codes End.

    const record = ref({
      condDeptCodes: null,
      condDeptNames: null,
      condRegionCodes: null,
      condRegionNames: null,
      interestContentNames: null,
      interestContentCodes: null,
      interestContentStartDate: dayjs().add(-2, 'month').format('YYYY-MM-DD'),
    })

    const showMediDeptSelect = ref(false)
    const mediDeptSelect = {
      close: rs => {
        showMediDeptSelect.value = false

        if (rs) {
          // 진료과 타입의 필터들을 targetGroupFilters에서 제거
          targetGroupData.value.targetGroupFilters = targetGroupData.value.targetGroupFilters.filter(f => f.filterType !== departmentTypeCode.value)

          // 선택 진료과 추가
          const newFilters = []

          rs.forEach(item => {
            newFilters.push({
              filterType: departmentTypeCode.value,
              filterId: item.code,
              filterName: item.label,
            })
          })

          targetGroupData.value.targetGroupFilters.push(...newFilters)

          record.value.condDeptCodes = arrayJoinStr(rs, 'code')
          record.value.condDeptNames = arrayJoinStr(rs, 'label')
        }
      },
    }

    const showRegionSelect = ref(false)
    const regionSelect = {
      close: rs => {
        showRegionSelect.value = false

        if (rs) {
          // 지역 타입의 필터들을 targetGroupFilters에서 제거
          targetGroupData.value.targetGroupFilters = targetGroupData.value.targetGroupFilters.filter(f => f.filterType !== regionTypeCode.value)

          // 선택 지역 추가
          const newFilters = []

          rs.forEach(item => {
            newFilters.push({
              filterType: regionTypeCode.value,
              filterId: item.code,
              filterName: item.label,
            })
          })

          targetGroupData.value.targetGroupFilters.push(...newFilters)

          record.value.condRegionCodes = arrayJoinStr(rs, 'code')
          record.value.condRegionNames = arrayJoinStr(rs, 'label')
        }
      },
    }

    const showInterestContentSelect = ref(false)
    const interestContentSelect = {
      close: rs => {
        showInterestContentSelect.value = false

        if (rs) {
          // 관심 컨텐츠 타입의 필터들을 targetGroupFilters에서 제거
          targetGroupData.value.targetGroupFilters = targetGroupData.value.targetGroupFilters.filter(f => f.filterType !== interestContentTypeCode.value)

          const newFilters = []

          rs.forEach(item => {
            newFilters.push({
              filterType: interestContentTypeCode.value,
              filterId: item.id,
              filterName: item.title,
              startDate: record.value.interestContentStartDate,
            })
          })

          targetGroupData.value.targetGroupFilters.push(...newFilters)

          record.value.interestContentCodes = arrayJoinStr(rs, 'id')
          record.value.interestContentNames = arrayJoinStr(rs, 'title')
        }
      },
    }

    // Query Data
    const filterStr = ref('')
    // Query Data End.

    const ReleaseDate2nd = process.env.NODE_ENV === 'production' ? '2025-10-24' : '2025-08-28'

    const isSaving = ref(false)
    const bvModal = instance.proxy.$bvModal

    // Main Table Config
    const targetGroupInitState = () => ({
      id: null,
      targetGroupTitle: null,
      targetGroupFilters: [], // 타겟마다 항목 다름(사용시 주의)
    })
    const targetGroupData = ref(targetGroupInitState())

    const targetGroupEtcInitState = () => ({
      copyDisabled: false,
      isBeforeReleaseDate2nd: true,
      targetCountInfo: {
        count: 0,
        isLoading: false,
        showTargetCountDetail: false,
        targetCountDetailList: [],
      },
    })
    const targetGroupEtcData = ref(targetGroupEtcInitState())

    watch(() => record.value.interestContentStartDate, newVal => {
      // watch 위치 주의: targetGroupData 아래에 위치해야함
      if (newVal && targetGroupData.value.targetGroupFilters) {
        targetGroupData.value.targetGroupFilters = targetGroupData.value.targetGroupFilters.map(filter => {
          if (filter.filterType === interestContentTypeCode.value) {
            return {
              ...filter,
              startDate: newVal,
            }
          }
          return filter
        })
      }
    })

    const targetGroupList = ref([])
    const totalRecords = ref(0)
    const targetCountFormatter = (value, key, item) => (`${value} 명 ${item.isExcludeCollection ? '제외' : '포함'}`)
    // const excludeFormatter = value => (value ? "exclude Set" : "Include Set")
    const statusFormatter = value => codes.value.targetGroupStatus?.find(t => t.code === value).label
    const dateFormatter = value => dayjs(new Date(value)).format('YY-MM-DD')
    const tableColumns = [
      {
        key: 'id', label: 'ID', sortable: true, thStyle: { width: '8%' },
      },
      { key: 'targetGroupTitle', label: '이름', sortable: true },
      {
        key: 'collectedCount', label: '타겟인원수', sortable: true, formatter: targetCountFormatter, thStyle: { width: '20%' }, tdClass: 'text-right',
      },
      {
        key: 'status', label: '그룹상태', sortable: true, formatter: statusFormatter, thStyle: { width: '10%' }, tdClass: 'text-center',
      },
      {
        key: 'createDate', label: '등록일자', sortable: true, formatter: dateFormatter, thStyle: { width: '10%' }, tdClass: 'text-center',
      },
    ]
    const refetchData = () => {
      fetchTargetGroups()
    }

    const onRowSelected = items => {
      const item = items[0]
      if (item) {
        getData(item.id)
      }
    }
    // Main Table Config End.

    const fetchCodes = () => {
      axios.get('/fa/target-group/codes')
        .then(rs => {
          const {
            targetGroupStatus, targetGroupFilterType, targetGroupCountType, targetGroupActionType,
            postViewerRouteType, popupNonClickerRouteType,
          } = rs.data
          codes.value.targetGroupStatus = targetGroupStatus
          codes.value.targetGroupFilterType = targetGroupFilterType
          codes.value.targetGroupCountType = targetGroupCountType
          codes.value.targetGroupActionType = targetGroupActionType
          codes.value.postViewerRouteType = postViewerRouteType
          codes.value.popupNonClickerRouteType = popupNonClickerRouteType
          refetchData()
        })
        .catch(() => {
          pushToast('danger', '코드 데이터를 불러오는데 실패하였습니다.')
        })
    }

    const fetchTargetGroups = () => {
      axios.post('/fa/target-group/list', {
        search: {
          filterStr: filterStr.value,
        },
        sort: {
          predicate: 'id',
          reverse: true,
        },
      })
        .then(rs => {
          const { items, totalRecord } = rs.data
          targetGroupList.value = items
          totalRecords.value = totalRecord
        })
        .catch(() => {
          pushToast('danger', '타겟그룹 목록 조회에 실패하였습니다.')
        })
    }

    const getData = id => {
      axios.get(`/fa/target-group/${id}`)
        .then(rs => {
          Object.assign(targetGroupEtcData.value, targetGroupEtcInitState())
          Object.keys(hasValidFilters.value).forEach(key => {
            hasValidFilters.value[key] = true
          })
          targetGroupData.value = rs.data

          // 필터 토글 상태 설정
          const hasDepartmentFilters = targetGroupData.value.targetGroupFilters?.some(f => f.filterType === departmentTypeCode.value) || false
          filterToggleStates.value.department = hasDepartmentFilters

          const hasRegionFilters = targetGroupData.value.targetGroupFilters?.some(f => f.filterType === regionTypeCode.value) || false
          filterToggleStates.value.region = hasRegionFilters

          const hasLiveDiFilters = targetGroupData.value.targetGroupFilters?.some(f => f.filterType === liveDiTypeCode.value) || false
          filterToggleStates.value.liveDi = hasLiveDiFilters

          const hasActivityFilters = targetGroupData.value.targetGroupFilters?.some(f => f.filterType === activityDrugInfoTypeCode.value || f.filterType === activityMedicalTrendTypeCode.value || f.filterType === activitySurveyTypeCode.value) || false
          filterToggleStates.value.activity = hasActivityFilters

          const hasInterestContentFilters = targetGroupData.value.targetGroupFilters?.some(f => f.filterType === interestContentTypeCode.value) || false
          filterToggleStates.value.interestContent = hasInterestContentFilters

          const hasSurveyAnswerFilters = targetGroupData.value.targetGroupFilters?.some(f => f.filterType === surveyAnswerTypeCode.value) || false
          filterToggleStates.value.surveyAnswer = hasSurveyAnswerFilters

          const hasDrugLandingFilters = targetGroupData.value.targetGroupFilters?.some(f => f.filterType === drugLandingTypeCode.value) || false
          filterToggleStates.value.drugLanding = hasDrugLandingFilters

          if (dayjs(targetGroupData.value.createDate).isBefore('2025-08-28')) {
            // 라이브 DI 배포 이전데이터는 복사 불가
            targetGroupEtcData.value.copyDisabled = true
          }

          if (dayjs(targetGroupData.value.createDate).isBefore(ReleaseDate2nd)) {
            targetGroupEtcData.value.isBeforeReleaseDate2nd = false
          } else {
            targetGroupEtcData.value.targetCountInfo.count = targetGroupData.value.collectedCount
            targetGroupEtcData.value.isBeforeReleaseDate2nd = true
          }

          // 지역 값 적용
          if (hasRegionFilters) {
            const tmp = targetGroupData.value.targetGroupFilters.filter(f => f.filterType === regionTypeCode.value).map(p => (
              {
                code: p.filterId,
                label: p.filterName,
              }
            ))

            record.value.condRegionCodes = arrayJoinStr(tmp, 'code')
            record.value.condRegionNames = arrayJoinStr(tmp, 'label')
          }

          // 진료과 값 적용
          if (hasDepartmentFilters) {
            const tmp = targetGroupData.value.targetGroupFilters.filter(f => f.filterType === departmentTypeCode.value).map(p => (
              {
                code: p.filterId,
                label: p.filterName,
              }
            ))

            record.value.condDeptCodes = arrayJoinStr(tmp, 'code')
            record.value.condDeptNames = arrayJoinStr(tmp, 'label')
          }

          // 관심 컨텐츠 값 적용
          if (hasInterestContentFilters) {
            const tmp = targetGroupData.value.targetGroupFilters.filter(f => f.filterType === interestContentTypeCode.value).map(p => (
              {
                code: p.filterId,
                label: p.filterName,
              }
            ))
            record.value.interestContentCodes = arrayJoinStr(tmp, 'code')
            record.value.interestContentNames = arrayJoinStr(tmp, 'label')
            record.value.interestContentStartDate = targetGroupData.value.targetGroupFilters.filter(f => f.filterType === interestContentTypeCode.value)[0]?.startDate
          }
        })
        .catch(() => {
          pushToast('danger', '타겟그룹 상세 조회에 실패하였습니다.')
        })
    }

    const resetTargetGroup = () => {
      Object.assign(targetGroupData.value, targetGroupInitState())
      Object.assign(targetGroupEtcData.value, targetGroupEtcInitState())
      // activeFilterTypes.value = []
      Object.keys(filterToggleStates.value).forEach(key => {
        filterToggleStates.value[key] = false
      })
      Object.keys(hasValidFilters.value).forEach(key => {
        hasValidFilters.value[key] = true
      })
      refs.formRules.reset()
    }

    const saveTargetGroup = () => {
      const validPromise = refs.formRules.validate()
      const departmentValidPromise = refs.departmentRules.validate()
      const regionValidPromise = refs.regionRules.validate()
      const interestContentRules = refs.interestContentRules.validate()

      validPromise.then(valid => {
        departmentValidPromise.then(dv => {
          regionValidPromise.then(rv => {
            interestContentRules.then(icv => {
              if (!valid) return

              if (!targetGroupData.value.id) {
                if (!validateTargetFilters(dv, rv, icv)) return
              }

              if (targetGroupData.value.targetGroupFilters.length < 1) {
                pushToast('danger', '타겟그룹 조건이 설정되지 않았습니다.')
                return
              }

              if (targetGroupData.value.id) {
                updateTargetGroup()
              } else {
                createTargetGroup()
              }
            })
          })
        })
      })
    }

    const validateTargetFilters = (departmentValid, regionValid, interestContentValid) => {
      const filters = targetGroupData.value.targetGroupFilters
      Object.keys(hasValidFilters.value).forEach(key => {
        hasValidFilters.value[key] = true
      })

      // departmentTypeCode 조건 체크
      if (filterToggleStates.value.department) {
        // const departmentValid = await refs.departmentRules.validate()
        if (!departmentValid) {
          // pushToast('danger', '진료과를 입력해 주세요.')
          return false
        }
      }

      // regionTypeCode 조건 체크
      if (filterToggleStates.value.region) {
        // const regionValid = await refs.regionRules.validate()
        if (!regionValid) {
          // pushToast('danger', '지역을 입력해 주세요.')
          return false
        }
      }

      // liveDiTypeCode 조건 체크
      const liveDiFilters = filters.filter(item => item.filterType === liveDiTypeCode.value)
      if (filterToggleStates.value.liveDi && liveDiFilters.length === 0) {
        hasValidFilters.value.liveDi = false
      }
      if (liveDiFilters.length > 0) {
        const invalid = liveDiFilters.some(item => item.minCount === null || item.minCount === undefined || item.minCount === '' || Number.isNaN(item.minCount))
        if (invalid) {
          pushToast('danger', '처방 횟수를 모두 입력해 주세요.')
          return false
        }
        const hasConflict = liveDiFilters.some(f1 => liveDiFilters.some(f2 => f1.isExclude !== f2.isExclude && f1.filterId === f2.filterId && f1.countType === f2.countType && f1.minCount === f2.minCount))
        if (hasConflict) {
          pushToast('danger', '포함과 제외에 같은 조건의 라이브DI가 설정되어 있습니다. 타겟 인원이 0명이 되지 않도록 변경해 주세요.')
          return false
        }
      }

      // activityTypeCode 조건 체크
      const activityFilters = filters.filter(item => item.filterType === activityDrugInfoTypeCode.value || item.filterType === activityMedicalTrendTypeCode.value || item.filterType === activitySurveyTypeCode.value)
      if (filterToggleStates.value.activity && activityFilters.length === 0) {
        hasValidFilters.value.activity = false
      }
      if (activityFilters.length > 0) {
        // 타겟 경로가 필요한 액션타입: 컨텐츠 열람(11)·팝업 클릭(21)·팝업 무시(22)
        const ACTION_TYPES_WITH_ROUTE = [11, 21, 22]
        // 하단(조회기간) UI가 없는 액션타입: 컨텐츠 미열람(12)·팝업 미노출(23)·설문 미완료(32)
        const ACTION_TYPES_HIDING_LOWER_UI = [12, 23, 32]

        const activityDrugInfoFilters = filters.filter(item => item.filterType === activityDrugInfoTypeCode.value)
        if (activityDrugInfoFilters.length > 0) {
          const invalidActionType = activityDrugInfoFilters.some(item => item.targetActionType === null || item.targetActionType === undefined || item.targetActionType === '')
          if (invalidActionType) {
            pushToast('danger', '활동 타겟의 타겟 대상을 선택해 주세요.')
            return false
          }

          const invalidTargetRoute = activityDrugInfoFilters.some(item => ACTION_TYPES_WITH_ROUTE.includes(item.targetActionType)
              && (item.targetRouteCodes === null || item.targetRouteCodes === undefined || item.targetRouteCodes === ''))
          if (invalidTargetRoute) {
            pushToast('danger', '활동 타겟의 타겟 경로를 선택해 주세요.')
            return false
          }
        }
        const invalidDateRange = activityFilters.some(item => !ACTION_TYPES_HIDING_LOWER_UI.includes(item.targetActionType)
            && (item.startDate === null || item.startDate === undefined || item.startDate === '' || item.endDate === null || item.endDate === undefined || item.endDate === ''))
        if (invalidDateRange) {
          pushToast('danger', '활동 타겟의 조회 기간을 입력해 주세요.')
          return false
        }

        if (activityFilterValidFlag.value === false) {
          pushToast('danger', '활동 타겟의 조건이 올바르지 않습니다. 활동 조건을 다시 설정해 주세요.')
          return false
        }
      }

      // interestContentTypeCode 조건 체크
      if (filterToggleStates.value.interestContent) {
        if (!interestContentValid) {
          return false
        }
      }

      // surveyAnswerTypeCode 조건 체크
      const surveyAnswerFilters = filters.filter(item => item.filterType === surveyAnswerTypeCode.value)
      if (filterToggleStates.value.surveyAnswer && surveyAnswerFilters.length === 0) {
        hasValidFilters.value.surveyAnswer = false
      }

      // drugLandingTypeCode 조건 체크
      const drugLandingFilters = filters.filter(item => item.filterType === drugLandingTypeCode.value)
      if (filterToggleStates.value.drugLanding && drugLandingFilters.length === 0) {
        hasValidFilters.value.drugLanding = false
      }

      if (Object.values(hasValidFilters.value).some(v => v === false)) {
        return false
      }

      return true
    }

    const createTargetGroup = () => {
      try {
        isSaving.value = true // 중복 저장 방지용
        axios.post('/fa/target-group/new', targetGroupData.value)
          .then(rs => {
            pushToast('success', '신규 타겟그룹 등록 완료')
            refetchData()
            resetTargetGroup()
            // targetGroupData.value.id = rs.data.id
            isSaving.value = false
          })
          .catch(error => {
            isSaving.value = false
            pushToast('danger', errorFormatter(error, '타겟그룹 등록 과정에서 오류가 발생하였습니다.'))
          })
      } catch (ex) {
        isSaving.value = false
        pushToast('danger', errorFormatter(ex, '신규 타겟그룹을 등록하는 과정에서 오류가 발생하였습니다.'))
      }
    }

    const updateTargetGroup = () => {
      try {
        axios.patch('/fa/target-group/update', targetGroupData.value)
          .then(rs => {
            pushToast('success', '타겟그룹 수정 완료')
            refetchData()
            resetTargetGroup()
            // targetGroupData.value.id = rs.data.id
          })
          .catch(error => {
            pushToast('danger', errorFormatter(error, '타겟그룹 수정 과정에서 오류가 발생하였습니다.'))
          })
      } catch (ex) {
        pushToast('danger', errorFormatter(ex, '타겟그룹 변경사항을 저장하는 과정에서 오류가 발생하였습니다.'))
      }
    }

    const removeTargetGroup = () => {
      if (!targetGroupData.value.id) {
        pushToast('warning', '삭제할 대상을 선택하세요.')
        return
      }
      bvModal.msgBoxConfirm('삭제 하시겠습니까?', {
        size: 'sm',
        cancelVariant: 'outline-secondary',
        centered: true,
      })
        .then(confirm => {
          if (!confirm) return

          axios.delete(`/fa/target-group/${targetGroupData.value.id}`)
            .then(() => {
              pushToast('success', '데이터 삭제 완료')
              refetchData()
              resetTargetGroup()
            })
            .catch(error => {
              pushToast('danger', errorFormatter(error, '삭제하는 과정에서 오류가 발생하였습니다.'))
            })
        })
    }

    const copyTargetGroup = () => {
      if (targetGroupData.value.id) {
        targetGroupData.value.id = null
        targetGroupData.value.targetGroupTitle = null
        Object.assign(targetGroupEtcData.value, targetGroupEtcInitState())
      }
    }

    // Toggle
    // 활성화된 필터 타입
    // const activeFilterTypes = ref([])
    // 활성화된 필터 타입을 정렬된 순서로 반환
    const activeFilterTypes = computed(() => {
      const filterOrder = [
        { key: 'department', code: departmentTypeCode.value },
        { key: 'region', code: regionTypeCode.value },
        { key: 'liveDi', code: liveDiTypeCode.value },
        { key: 'activity', code: activityTypeCode.value },
        { key: 'interestContent', code: interestContentTypeCode.value },
        { key: 'surveyAnswer', code: surveyAnswerTypeCode.value },
        { key: 'drugLanding', code: drugLandingTypeCode.value },
      ]

      return filterOrder
        .filter(filter => filterToggleStates.value[filter.key])
        .map(filter => filter.code)
        .filter(code => code !== undefined)
    })
    // 필터 토글 상태
    const filterToggleStates = ref({
      liveDi: false,
      department: false,
      region: false,
      activity: false,
      interestContent: false,
      surveyAnswer: false,
      drugLanding: false,
    })

    // 필수 입력 체크 필터
    const hasValidFilters = ref({
      liveDi: true,
      department: true,
      region: true,
      activity: true,
      interestContent: true,
      surveyAnswer: true,
      drugLanding: true,
    })

    watch(() => filterToggleStates.value.liveDi, newValue => {
      filterToggleChange(liveDiTypeCode.value, newValue)
    })

    watch(() => filterToggleStates.value.department, newValue => {
      filterToggleChange(departmentTypeCode.value, newValue)
    })

    watch(() => filterToggleStates.value.region, newValue => {
      filterToggleChange(regionTypeCode.value, newValue)
    })

    watch(() => filterToggleStates.value.activity, newValue => {
      // filterToggleChange(activityTypeCode.value, newValue)
      if (!newValue) {
        targetGroupData.value.targetGroupFilters = targetGroupData.value.targetGroupFilters.filter(
          f => f.filterType !== activityDrugInfoTypeCode.value && f.filterType !== activityMedicalTrendTypeCode.value && f.filterType !== activitySurveyTypeCode.value,
        )
      }
    })

    watch(() => filterToggleStates.value.interestContent, newValue => {
      filterToggleChange(interestContentTypeCode.value, newValue)
    })

    watch(() => filterToggleStates.value.surveyAnswer, newValue => {
      filterToggleChange(surveyAnswerTypeCode.value, newValue)
    })

    watch(() => filterToggleStates.value.drugLanding, newValue => {
      filterToggleChange(drugLandingTypeCode.value, newValue)
    })

    const filterToggleChange = (filterTypeCode, isToggleOn) => {
      // if (isToggleOn) {
      //   if (!activeFilterTypes.value.includes(filterTypeCode)) {
      //     activeFilterTypes.value.push(filterTypeCode)
      //   }
      // } else {
      //   const index = activeFilterTypes.value.indexOf(filterTypeCode)
      //   if (index > -1) {
      //     activeFilterTypes.value.splice(index, 1)
      //   }
      //   // 해당 타입의 필터들을 targetGroupFilters에서 제거
      //   targetGroupData.value.targetGroupFilters = targetGroupData.value.targetGroupFilters.filter(
      //     f => f.filterType !== filterTypeCode,
      //   )
      // }
      if (!isToggleOn) {
        // 해당 타입의 필터들을 targetGroupFilters에서 제거
        targetGroupData.value.targetGroupFilters = targetGroupData.value.targetGroupFilters.filter(
          f => f.filterType !== filterTypeCode,
        )

        // 지역, 진료과인 경우 selected 초기화
        if (filterTypeCode === departmentTypeCode.value) {
          record.value.condDeptCodes = null
          record.value.condDeptNames = null
        }

        if (filterTypeCode === regionTypeCode.value) {
          record.value.condRegionCodes = null
          record.value.condRegionNames = null
        }

        if (filterTypeCode === interestContentTypeCode.value) {
          record.value.interestContentCodes = null
          record.value.interestContentNames = null
          record.value.interestContentStartDate = dayjs().add(-2, 'month').format('YYYY-MM-DD')
        }
      }
    }

    const getFilterName = filterType => {
      const typeCode = parseInt(filterType, 10)
      switch (typeCode) {
        case liveDiTypeCode.value:
          return '처방(라이브 DI)'
        case departmentTypeCode.value:
          return '진료과'
        case regionTypeCode.value:
          return '지역'
        case activityTypeCode.value:
          return '활동'
        case interestContentTypeCode.value:
          return '관심 컨텐츠 유형'
        case surveyAnswerTypeCode.value:
          return '설문응답'
        case drugLandingTypeCode.value:
          return '간편처방'
        default:
          return `필터 ${filterType}`
      }
    }
    // Toggle End.

    // Target count
    const getTargetCount = () => {
      targetGroupEtcData.value.targetCountInfo.isLoading = true
      targetGroupEtcData.value.targetCountInfo.count = 0

      const departmentValidPromise = refs.departmentRules.validate()
      const regionValidPromise = refs.regionRules.validate()
      const interestContentValidPromise = refs.interestContentRules.validate()

      departmentValidPromise.then(dv => {
        regionValidPromise.then(rv => {
          interestContentValidPromise.then(icv => {
            if (!validateTargetFilters(dv, rv, icv)) {
              targetGroupEtcData.value.targetCountInfo.isLoading = false
              return
            }
            getTargetCountDetail()
          })
        })
      })
    }

    const showTargetCountDetailModal = () => {
      if (!targetGroupEtcData.value.targetCountInfo.targetCountDetailList.length) {
        const departmentValidPromise = refs.departmentRules.validate()
        const regionValidPromise = refs.regionRules.validate()
        const interestContentValidPromise = refs.interestContentRules.validate()

        departmentValidPromise.then(dv => {
          regionValidPromise.then(rv => {
            interestContentValidPromise.then(icv => {
              if (validateTargetFilters(dv, rv, icv)) {
                getTargetCountDetail()
              }
            })
          })
        })
      }
      targetGroupEtcData.value.targetCountInfo.showTargetCountDetail = true
    }

    const getTargetCountDetail = () => {
      axios.post("/fa/target-group/target-count-detail", {
        id: targetGroupData.value.id,
        filters: targetGroupData.value.targetGroupFilters,
      })
        .then(rs => {
          targetGroupEtcData.value.targetCountInfo.targetCountDetailList = rs.data.list
          targetGroupEtcData.value.targetCountInfo.count = rs.data.totalCount
          targetGroupEtcData.value.targetCountInfo.isLoading = false
        })
        .catch(() => {
          pushToast('danger', '상세 인원 데이터를 불러오지 못했습니다.')
          targetGroupEtcData.value.targetCountInfo.isLoading = false
        })
    }
    // Target Count End.

    return {
      filterStr,
      targetGroupList,
      fetchTargetGroups,
      refetchData,
      resetTargetGroup,
      saveTargetGroup,
      removeTargetGroup,
      onRowSelected,
      tableColumns,
      totalRecords,
      targetGroupData,
      required,
      isSaving,
      codes,
      liveDiTypeCode,
      departmentTypeCode,
      regionTypeCode,
      activityTypeCode,
      interestContentTypeCode,
      surveyAnswerTypeCode,
      drugLandingTypeCode,
      activityDrugInfoTypeCode,
      activityMedicalTrendTypeCode,
      activitySurveyTypeCode,
      getData,
      activeFilterTypes,
      getFilterName,
      filterToggleStates,
      hasValidFilters,
      getTargetCount,
      getTargetCountDetail,
      targetGroupEtcData,
      copyTargetGroup,
      ReleaseDate2nd,
      showTargetCountDetailModal,
      activityFilterValidFlag,

      record,
      mediDeptSelect,
      showMediDeptSelect,
      regionSelect,
      showRegionSelect,
      interestContentSelect,
      showInterestContentSelect,

      yesterdayDate,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>

<style scoped>
.btn-hover-trash:hover {
  background: linear-gradient(to right, #ffe5e5, #ffcccc);
  border-radius: 4px;
}

.btn-with-divider::after {
  content: "|";
  color: #6c757d;
  margin-left: 0.75rem;
  margin-right: 0.75rem;
  font-weight: normal;
}
</style>
